export const FilterOperatorIgnor = ['IsEmpty', 'IsNotEmpty'];
